import { getActiveBranchId } from '@/shared/api/apiClient';
import { bizDelete, bizGet, bizPatch, bizPost } from '@/shared/api/bizClient';

import type {
  BusinessScheduleException,
  BusinessStaff,
  BusinessWorkSchedule,
  UpsertBusinessScheduleExceptionPayload,
  UpsertBusinessStaffPayload,
} from './types';

interface ListEnvelope<T> {
  items: T[];
}

function branchParams(): { branchId?: string } {
  const branchId = getActiveBranchId();
  return branchId ? { branchId } : {};
}

export async function listBusinessStaff(): Promise<BusinessStaff[]> {
  const response = await bizGet<ListEnvelope<BusinessStaff>>('/biz/staff', {
    params: branchParams(),
  });
  return response.items;
}

export async function createBusinessStaff(
  payload: UpsertBusinessStaffPayload,
): Promise<BusinessStaff> {
  return bizPost<BusinessStaff, UpsertBusinessStaffPayload>('/biz/staff', payload);
}

export async function updateBusinessStaff(
  staffId: string,
  payload: Partial<UpsertBusinessStaffPayload>,
): Promise<BusinessStaff> {
  return bizPatch<BusinessStaff, Partial<UpsertBusinessStaffPayload>>(
    `/biz/staff/${staffId}`,
    payload,
  );
}

export async function listBusinessWorkSchedules(
  staffId: string,
): Promise<BusinessWorkSchedule[]> {
  const response = await bizGet<ListEnvelope<BusinessWorkSchedule>>(
    `/biz/staff/${staffId}/schedules`,
  );
  return response.items;
}

export async function listBusinessScheduleExceptions(
  staffId: string,
): Promise<BusinessScheduleException[]> {
  const response = await bizGet<ListEnvelope<BusinessScheduleException>>(
    `/biz/staff/${staffId}/exceptions`,
  );
  return response.items;
}

export async function upsertBusinessScheduleException(
  staffId: string,
  payload: UpsertBusinessScheduleExceptionPayload,
): Promise<BusinessScheduleException> {
  return bizPost<BusinessScheduleException, UpsertBusinessScheduleExceptionPayload>(
    `/biz/staff/${staffId}/exceptions`,
    payload,
  );
}

export async function deleteBusinessScheduleException(
  staffId: string,
  exceptionId: string,
): Promise<void> {
  await bizDelete<void>(`/biz/staff/${staffId}/exceptions/${exceptionId}`);
}
